import { render, staticRenderFns } from "./EditDepositRule.vue?vue&type=template&id=1bf64fc9"
import script from "./EditDepositRule.vue?vue&type=script&lang=ts"
export * from "./EditDepositRule.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports